export const normalizarLinksZoom = (responseData) => {
  if (Array.isArray(responseData)) return responseData;
  if (Array.isArray(responseData?.data)) return responseData.data;
  if (Array.isArray(responseData?.links)) return responseData.links;
  return [];
};

const obtenerPartesFecha = (fecha) => {
  const textoFecha = String(fecha || '').trim();
  const formatoIso = textoFecha.match(/^(\d{4})-(\d{2})-(\d{2})/);

  if (formatoIso) {
    return {
      year: Number(formatoIso[1]),
      month: Number(formatoIso[2]),
      day: Number(formatoIso[3]),
    };
  }

  const fechaParseada = new Date(textoFecha);
  if (Number.isNaN(fechaParseada.getTime())) return null;

  if (/GMT|UTC/i.test(textoFecha)) {
    return {
      year: fechaParseada.getUTCFullYear(),
      month: fechaParseada.getUTCMonth() + 1,
      day: fechaParseada.getUTCDate(),
    };
  }

  return {
    year: fechaParseada.getFullYear(),
    month: fechaParseada.getMonth() + 1,
    day: fechaParseada.getDate(),
  };
};

const crearFechaHoraLocal = (fecha, hora) => {
  const partesFecha = obtenerPartesFecha(fecha);
  if (!partesFecha) return null;

  const [hours = 0, minutes = 0, seconds = 0] = String(hora || '00:00:00')
    .split(':')
    .map(Number);

  const fechaHora = new Date(
    partesFecha.year,
    partesFecha.month - 1,
    partesFecha.day,
    hours,
    minutes,
    seconds,
  );

  return Number.isNaN(fechaHora.getTime()) ? null : fechaHora;
};

export const obtenerProximaReunionCurso = (links, matriculaClase, ahora = new Date()) => {
  if (!matriculaClase) return null;

  const matriculaBuscada = String(matriculaClase);

  return links
    .filter(
      (link) =>
        String(link?.matricula_clase || '') === matriculaBuscada && link?.url,
    )
    .map((link) => ({ ...link, fechaHora: crearFechaHoraLocal(link.fecha, link.hora) }))
    .filter((link) => link.fechaHora && link.fechaHora.getTime() >= ahora.getTime())
    .sort((a, b) => a.fechaHora.getTime() - b.fechaHora.getTime())[0] || null;
};

export const formatearFechaReunion = (fechaHora) => {
  if (!(fechaHora instanceof Date) || Number.isNaN(fechaHora.getTime())) return '';

  return fechaHora.toLocaleDateString('es-MX', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};

export const formatearHoraReunion = (fechaHora) => {
  if (!(fechaHora instanceof Date) || Number.isNaN(fechaHora.getTime())) return '';

  return fechaHora.toLocaleTimeString('es-MX', {
    hour: '2-digit',
    minute: '2-digit',
  });
};
